import { render } from "./Halfcutservices.vue?vue&type=template&id=1d87f7ea&scoped=true"
import script from "./Halfcutservices.vue?vue&type=script&lang=js"
export * from "./Halfcutservices.vue?vue&type=script&lang=js"

import "./Halfcutservices.vue?vue&type=style&index=0&id=1d87f7ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d87f7ea"]])

export default __exports__